import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CMSActions from "app/@Base/store/actions";
import * as CMSActionsAhorro from "../@Content/components/AhorroYCredito/store/actions/ahorroYCredito.actions";

export default function useCatalogs() {
  const dispatch = useDispatch();

  const { loggedUser } = useSelector(({ Base }) => Base?.User);
  const { token } = useSelector(({ Base }) => Base.Token);

  useEffect(() => {
    //API
    const { token } = loggedUser;
    if (token) {
      dispatch(CMSActions.getBienesSearch("", token));
      dispatch(CMSActions.getConveniosTiles(token));      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  useEffect(() => {
    //CMS
    if (token) {
      dispatch(CMSActions.getNavigationsRoute(token));
      dispatch(CMSActions.getMainMenuSections(token));
      dispatch(CMSActions.getBarraIntermedia(token)); 
      dispatch(CMSActionsAhorro.getComunicadosOficiales(token));
      dispatch(CMSActionsAhorro.getGestionPagos(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
}
